module.exports = {"id":"230319","name":"André Milazisco","rating":"71","photo":"./data/images/photos/3/230319.png","club":{"name":"Ponte Preta","logo":"./data/images/clubs/PontePreta.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreMilazisco0.json
// module id = 347
// module chunks = 0